import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY, NAV_LINKS } from "../../lib/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#050907] pt-20 pb-10 overflow-hidden">
      <div className="absolute inset-x-0 top-0 flex justify-center pointer-events-none select-none">
        <span className="font-serif-display text-[16vw] leading-none text-[#D4AF37] opacity-[0.04] whitespace-nowrap">
          North Emerald
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 pb-14 border-b border-white/5">
          <div className="md:col-span-5">
            <img src={COMPANY.logoLockup} alt="North Emerald Holdings LLC" className="h-36 w-auto object-contain mb-6" />
            <p className="text-[#A3B1A8] text-sm leading-relaxed max-w-sm">
              Property development and management built on quality, integrity, and responsible growth, creating
              well-cared-for properties and stronger neighborhoods.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="overline mb-5">Explore</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={`/${l.href}`} className="text-[#A3B1A8] hover:text-[#D4AF37] text-sm transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-[#A3B1A8] hover:text-[#D4AF37] text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms-link" className="text-[#A3B1A8] hover:text-[#D4AF37] text-sm transition-colors">
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="overline mb-5">Contact</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3 text-[#A3B1A8]">
                <Phone size={16} className="text-[#D4AF37] shrink-0" /> {COMPANY.phone}
              </li>
              <li className="flex items-center gap-3 text-[#A3B1A8]">
                <Mail size={16} className="text-[#D4AF37] shrink-0" /> {COMPANY.email}
              </li>
              <li className="flex items-start gap-3 text-[#A3B1A8]">
                <MapPin size={16} className="text-[#D4AF37] shrink-0 mt-0.5" /> {COMPANY.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#A3B1A8]/70 text-xs">
            © {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.
          </p>
          <p className="text-[#A3B1A8]/70 text-xs">Equal Housing Opportunity · Managed with integrity.</p>
        </div>
      </div>
    </footer>
  );
};
